import { PeekBox, PeekButton } from '@piiqtechnologies/ui-components';
import React, { useState } from 'react';
import { UploadStagedImageTool } from './upload-staged-image/UploadStagedImageTool.js';

const UploadStagedImageCtrl = () => {
    const [uploadStagedImageOpen, setUploadStagedImageOpen] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekBox, null,
            React.createElement(PeekButton, { onClick: () => setUploadStagedImageOpen(true), "aria-label": "Upload Staged Image", variant: "outlined", color: "secondary", sx: {
                    lineBreak: "auto",
                    height: "auto",
                    minHeight: 28,
                } }, "Upload Staged Image")),
        React.createElement(UploadStagedImageTool, { open: uploadStagedImageOpen, onClose: () => setUploadStagedImageOpen(false) })));
};

export { UploadStagedImageCtrl, UploadStagedImageCtrl as default };
